import React from 'react';
import PageHeader from '../../components/common/PageHeader';
import PageMeta from '../../components/common/PageMeta';
import Navbar from '../../layout/Header/Navbar';
import Layout from '../../layout/Layout';
import EventGrid from "./EventGrid";
import Footer from "../../components/Home/Footer";

const Events = () => {
  return (
    <Layout>
      <PageMeta title="Welcome Our Blog- Software &amp; IT Solutions HTML Templat" />
      <Navbar />
      <PageHeader
        title="Events"
        desc="If you're planning on attending any of the events listed, we'd love to meet you!

        We enjoy speaking with merchants across all industries and understanding what they are looking for in their payments partner. Whether you're well-established or just starting out, come and speak with us to learn how we can help you optimise your payments performance and grow."
      />
      <EventGrid />
      <Footer />
    </Layout>
  );
};

export default Events;
